// extracted by mini-css-extract-plugin
export var sliderRange = "_qz-2";
export var sliderRoot = "_qz-0";
export var sliderThumb = "_qz-3";
export var sliderTrack = "_qz-1";